exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-card[data-v-3f51f536]{border-left:4px solid #90a4ae!important}.pending-summary[data-v-3f51f536]{border-left-color:#ef6c00!important}.resubmit-summary[data-v-3f51f536]{border-left-color:#673ab7!important}.approved-summary[data-v-3f51f536]{border-left-color:#2e7d32!important}.rejected-summary[data-v-3f51f536]{border-left-color:#c62828!important}.admin-search[data-v-3f51f536]{max-width:280px}.notes-cell[data-v-3f51f536]{max-width:200px;white-space:normal}.action-buttons[data-v-3f51f536]{min-width:205px}", ""]);

// exports
